import React from "react";
import "../designcss/Helpingbusiness.css";

const Personalisedgrowpage = () => {
  return (
    <div className="business-wrapper">
      <div className="business-container">
        <div className="grows-smarter">
          <h1>Understanding Personalized </h1>
          <h1>Messaging on WhatsApp</h1>
        </div>

        <p className="business-api">
          Personalized messaging involves customizing WhatsApp communication
          based on customer information such as name, interests, purchase
          history, location, or stage in their journey. This approach ensures
          each message resonates with the recipient and encourages engagement.
        </p>

        <div className="vision-mission-container">
          <div className="cardd vision-card">
            <h3>The Value of Personalized Messaging</h3>
            <p>
              Generic messages are often ignored, while personalized messages
              spark action. By sending content tailored to individual customer
              needs and preferences, businesses see higher open rates, better
              responses, and increased engagement.
            </p>
          </div>

          <div className="cardd mission-card">
            <h3>Personalization at Scale with WoSender</h3>
            <p>
              WoSender makes it easy for businesses to deliver personalized
              WhatsApp messages to hundreds or thousands of users. Brands can
              segment audiences, customize messages with customer data, and send
              relevant offers and recommendations efficiently.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Personalisedgrowpage;
